<template>
  <div>
    <GlobalTable
      :title="title+' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="false"
      :isLoading="isLoading"
      @addForm="addForm"
      @editForm="editForm"
    ></GlobalTable>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{title}}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CForm>
          <CRow>
            <CCol sm="3">
              <CInput
                label="Name"
                invalid-feedback="Name should be filled"
                required
                v-model="$v.notificationTypeForm.name.$model"
                :is-valid="!$v.notificationTypeForm.name.$invalid"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="6">
              <CTextarea
                rows="4"
                label="Description"
                invalid-feedback="Description should be filled"
                required
                v-model="$v.notificationTypeForm.description.$model"
                :is-valid="!$v.notificationTypeForm.description.$invalid"
              />
            </CCol>
          </CRow>
        </CForm>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.notificationTypeForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import Loading from "../../../templates/Loading";

export default {
  name: "NotificationType",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "Notification Type",
      fields: [
        { key: "name", label: "Nama Status", sorter: true },
        { key: "description", label: "Description", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
      items: [],
      notificationTypeForm: tableInterfaces.notification_type,
      isLoading: false,
      addButton: false,
      isEdit: false,
    };
  },
  validations: {
    notificationTypeForm: {
      name: { required },
      description: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getProductGroup();
    },
    getProductGroup: function () {
      this.isLoading = true;
      this.axios
        .get("console/master/notification_type/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.notificationTypeForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.notification_type) {
        tableInterfaces.notification_type[i] = null;
      }
      this.notificationTypeForm = tableInterfaces.notification_type;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (this.isEdit === true) {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put(
              "console/master/notification_type/edit",
              this.notificationTypeForm
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      } else {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post(
              "console/master/notification_type/add",
              this.notificationTypeForm
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
